import {
  ActiveFilter,
  Filter,
  MainFilter,
  SearchFilter,
} from '@/components/Filters/types';

export type QueryParamValue =
  | string
  | number
  | boolean
  | null
  | undefined
  | Array<string>;

export interface QueryParams {
  [key: string]: string | Array<string> | undefined;
}

interface AllFilters {
  filters?: Array<Filter>;
  mainFilters?: Array<MainFilter>;
  searchFilters?: Array<SearchFilter>;
}

function isValueValid(value: QueryParamValue) {
  return value !== undefined && value !== null && value !== '';
}

export function convertFiltersToQueryParams(params?: Array<ActiveFilter>) {
  if (!params?.length) {
    return '';
  }

  const filteredParams = params.filter(({ value }) => isValueValid(value));

  if (filteredParams.length) {
    return `?${filteredParams
      .map(({ name, value }) => `${name}=${String(value)}`)
      .join('&')}`;
  }

  return '';
}

export function convertQueryParamsToFilters(
  query: QueryParams,
  allFilters: AllFilters
): Array<ActiveFilter> {
  const queryFilters: Array<ActiveFilter> = [];
  const { filters, searchFilters, mainFilters } = allFilters;

  Object.entries(query).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      value.forEach((v) => {
        queryFilters.push({
          name: key,
          value: v,
        });
      });
    } else {
      const filter: ActiveFilter = {
        name: key,
        value,
      };

      if (value === 'true') {
        filter.label = filters?.find(({ name }) => name === key)?.label;
      }

      queryFilters.push(filter);
    }
  });

  return queryFilters.map((activeFilter) => {
    const filterItem = filters
      ?.find((filter) => filter.name === activeFilter.name)
      ?.options?.find((option) => option.value === activeFilter.value);

    if (filterItem) {
      activeFilter.label = filterItem.label;
    }

    const mainFilterItem = mainFilters
      ?.find((filter) => filter.name === activeFilter.name)
      ?.options?.find((option) => option.value === activeFilter.value);

    if (mainFilterItem) {
      activeFilter.label = mainFilterItem.label;
      activeFilter.isMain = true;
    }

    const searchFilterItem = searchFilters?.find(
      (filter) => filter.name === activeFilter.name
    );

    if (searchFilterItem) {
      activeFilter.isMain = true;
    }

    return activeFilter;
  });
}

export function convertToQueryParams(params?: {
  [key: string]: QueryParamValue;
}) {
  if (!params) {
    return '';
  }

  const filteredParams = Object.entries(params).filter(([, value]) =>
    isValueValid(value)
  );

  if (filteredParams.length) {
    return `?${filteredParams
      .map(([key, value]) => `${key}=${String(value)}`)
      .join('&')}`;
  }

  return '';
}
